import { render, staticRenderFns } from "./DepositHistoryDetail.vue?vue&type=template&id=a3471f7e&"
import script from "./DepositHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./DepositHistoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports